export default __webpack_public_path__ + "static/media/about.a488f2f6.jpeg";